// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"7eff22cd","428":"c4b6ee54","628":"95a2191f"}[chunkId] + ".chunk.css";
};